module.exports = __webpack_public_path__ + "static/media/chat.66639537.svg";